import { atom } from 'recoil';

export const googleReviewReplyState = atom<string | null>({
  key: 'googleReviewReplyState',
  default: null
});